// src/utils/showNotificationToast.js
import toast from "react-hot-toast";
import React from "react";

export const showNotificationToast = (notification, onOpen, delay = 2000) => {
  setTimeout(() => {
    toast(
      (t) => (
        <div style={{ minWidth: "280px" }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>
            {notification.title}
          </div>

          <div style={{ fontSize: "0.9rem", color: "#555" }}>
            {notification.message}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
              marginTop: "10px",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
                if (onOpen) onOpen(notification);
              }}
              style={{
                background: "#0063a4",
                border: "none",
                color: "#fff",
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Open
            </button>

            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                background: "#e0e0e0",
                border: "none",
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Dismiss
            </button>
          </div>
        </div>
      ),
      {
        position: "top-right",
        duration: 6000,
      },
    );
  }, delay);
};
